<template>
  <div class="gameCard">
    <div class="team-rank">{{ rank }} <img :src="getArrow('rankColour')" width="12" height="12" alt="down arrow"
      /></div>
    <div class="image"><slot name="image"></slot></div>
    <div class="team-name">
      <div class="teamText">
        <slot name="teamName"></slot><br />
        <span class="country-name">{{ country }}</span>
      </div>
     
    </div>
 <div class="game-profits">{{ CurrencySymbol }} {{ TeamProfits }}</div>
    <div class="annual-profit annual-change">
      {{ CurrencySymbol }} {{ AnnualProfit }} million / year
    </div>
    <div class="last-year">
      Change:
      <span class="changeValue" :class="changeColour"
        >{{ AnnualChange }}
        <img :src="getArrow('changeColour')" width="12" height="12" alt="down arrow"
      /></span>
    </div>
    <div class="last-year">
      Previous Rank:
      <span class="changeValue" :class="rankColour">{{ rankChange }}
        <!-- <img :src="getArrow('rankColour')" width="12" alt="up arrow"> -->
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gameCard {
  color: $black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px 30px 50px 30px;

  @include respond(phone-only) {
    margin: 20px 20px 40px 20px;
  }
}

.team-rank {
  color: $white;
  font-size: 30px;
  align-self: flex-start;
  margin: 0px 0px -20px 0px;
  display:flex;
  flex-direction:row;
  justify-content: center;
  align-items: flex-end;

  @include respond(phone-only) {
    font-size: 20px;
  }
}

.image {
  padding: 20px 10px 20px 10px;
  border-radius: 20px;
}

.team-name {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 175px;
  height: 60px;
  text-align: center;
  color: $white;
  background: linear-gradient($blue, darken($blue,15%));
  border-radius: 20px;
  margin: 0px 0px 0px 0px;

  @include respond(phone-only) {
    width: 125px;
    height: 45px;
    font-size: 12px;
  }
}

.teamText {
  margin-top: 5px;
  @include respond(phone-only) {
    margin-top: 2px;
  }
}

.country-name {
  font-size: 12px;
}

.game-profits {
  color: $white;
  font-family: Play, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 30px;
  font-weight: bold;
  margin: -18px 0px 0px 0px;
  padding: 0px 0px 10px 0px;
  @include respond(phone-only) {
    font-size: 20px;
    margin: -10px 0px 0px 0px;
  }
}

.annual-profit {
  color: $text_grey3;
  font-size: 16px;
  @include respond(phone-only) {
    font-size: 12px;
  }
}

.last-year {
  color: $yellow;
  font-size: 16px;
  margin: 4px 0px 0px 0px;
  font-style: italic;
  @include respond(phone-only) {
    font-size: 12px;
  }
}

.annual-change {
  margin: 10px 0px 0px 0px;
}

.changeValue {
  color: $white;
}

.positiveChange {
  color: $green;
}

.negativeChange {
  color: $red;
}
</style>

<script>
export default {
  props: {
    rank: Number,
    earningRate: Number,
    annualProfit: Number,
    prevEarnings: Number,
    prevRank: Number,
    country: String,
  },
  data() {
    return {
      percentChange:
        ((this.annualProfit - this.prevEarnings) / this.prevEarnings) * 100,
    };
  },
  computed: {
    CurrencySymbol() {
      return this.$store.getters.getCurrencySymbol;
    },

    TeamProfits() {
      const GameProfitFactor = this.$store.getters.getGameProfitFactor;
      return this.humanFormat(Math.floor(GameProfitFactor * this.earningRate));
    },
    AnnualProfit() {
      const currencyRate = this.$store.getters.getCurrencyRate;
      return this.humanFormat(Math.floor(this.annualProfit * currencyRate));
    },
    AnnualChange() {
      if (this.prevEarnings == 0) {
        return " -- ";
      }
      // this.percentChange = (this.annualProfit - this.prevEarnings) / this.prevEarnings *100;
      return this.percentChange.toFixed(2) + "%";
    },
    rankChange() {
      if (this.prevRank == 31) {
        return "30+";
      }
      return this.prevRank;
    },
    changeColour() {
      if (this.percentChange < 0) {
        return "negativeChange";
      } else {
        return "positiveChange";
      }
    },
    rankColour() {
      let rankDiff = this.rank - this.prevRank;
      if (this.prevRank == 31) {
        return "positiveChange";
      }

      if (rankDiff > 0) {
        return "negativeChange";
      } else if (rankDiff < 0) {
        return "positiveChange";
      } else {
        return null;
      }
    },
    getArrow(){
    
      return (computed) => {
          if (this[computed] == 'negativeChange') {
            return require("@/assets/images/arrow-down.png")
          }
          if (this[computed] == 'positiveChange') {
            return require("@/assets/images/arrow-up.png")
          }
    
      return require("@/assets/images/arrow-static.png");
    }
  },
  },
  methods: {
    humanFormat(profit) {
      return new Intl.NumberFormat().format(profit);
    },
  },
};
</script>